/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1StatData } from '../../entities/v1/StatData'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1AmountModelSchema } from './amountModelSchema'
import { z } from 'zod'

export const v1StatDataSchema = z.object({
  amount: z.lazy(() => v1AmountModelSchema),
  company_reward: z.number(),
  date: z.string(),
  done_orders: z.number().int(),
  drivee_comission: z.number(),
  drivers_revenue: z.number(),
}) as unknown as ToZod<V1StatData>